module.exports = __webpack_public_path__ + "img/logo.6f1dfaa3.png";